export default class extends Controller {
  static targets = ['field', 'checkbox'];

  connect() {
    this.toggle();
  }

  toggle() {
    this.fieldTarget.disabled = !!this.checkboxTarget.checked;
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/checkbox-enabled-field-controller.js